module.exports = __webpack_public_path__ + "img/cluster_health_100px_bluebox.aa112e95.png";